import { Column } from "primereact/column";
import { DataTableRowEditCompleteEvent, DataTable } from "primereact/datatable";
import { useState } from "react";

import { useLinks } from "../../../services/useData";
import { EducationLink } from "../../../types/firestore";
import { DisplayAs, Url } from "../../../util/const";


const EducationLinks = () => {

  const fetchedLinks = useLinks();
  const links = fetchedLinks.links;

  const [allLinks, setAllLinks] = useState(links);

  const onRowEditComplete = (e: DataTableRowEditCompleteEvent) => {
    let _rows = [...links];
    let { newData, index } = e;
    _rows[index] = newData as EducationLink;
    setAllLinks(_rows);
  };

    // const numberEditor = (options: ColumnEditorOptions) => {
  //   return <InputNumber value={options.value} onChange={(e: InputNumberChangeEvent) => options.editorCallback!(e.value)} style={{width:'4rem'}} />;
  // };

  return (
    <DataTable value={allLinks} editMode="row" dataKey="id" onRowEditComplete={onRowEditComplete} showGridlines stripedRows>
      <Column field="displayAs" header={DisplayAs} style={{ width:'20%'}}></Column>
      <Column field="url" header={Url} /*editor={(options) => numberEditor(options)}*/></Column>
      {/* <Column rowEditor={true}></Column> */}
    </DataTable>
  );
}

export default EducationLinks;